import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
import { ca } from '@cian/analytics';
export function sendTeaserWebEvent(payload, action) {
  var banner = payload.banner,
    bannerSource = payload.bannerSource,
    jsonQuery = payload.jsonQuery;
  ca('teaser', {
    sc: jsonQuery,
    product: {
      id: banner.id,
      name: "".concat(banner.name, "_").concat(action),
      position: banner.position,
      extra: _objectSpread(_objectSpread({
        bannerPlace: banner.place,
        bannerSource: bannerSource,
        action: action,
        eventDate: Date.now()
      }, banner.hitUrl && {
        hitUrl: banner.hitUrl
      }), banner.extra)
    }
  });
}